import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  colorCell: {
    minWidth: 90,
    width: 90,
    marginLeft: 8,
  },
  labelCell: {
    minWidth: 120,
    width: 120,
    marginRight: 8,
  },
  sticky: {
    position: "sticky",
    bottom: -24,
    backgroundColor: theme.props.backgroundSecondary,
    paddingBottom: 8,
  },
  noRemoval: {
    minWidth: 48,
    width: 48,
  },
  hover: {
    "&:not(:hover) .hoverIcon": {
      zIndex: -1,
      opacity: "0 !important",
    },
  }
}));

export default useStyle;